import type { FaireProductEntity } from "../../entity_types/product";

export const p_bpvp38yvgq: FaireProductEntity = {
  token: "p_bpvp38yvgq",
  type: "product",
  name: 'Blue Sardines 20" Tea Towel - Silkscreened 100% Cotton',
  brandToken: "b_7drubfti",
  brandName: "Julie Peach",
  imageUrl:
    "https://cdn.faire.com/fastly/6f32db6aed7213e419d62b90594f32f28a025d1c9f506c19fd17241016820013.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/abb6eb28cfe4ca3a573acca2956c28182afdfc38b09d307515fe49c0e929b709.jpeg",
    "https://cdn.faire.com/fastly/cb3f7ab79de9147ec9a26cddd27627b5deb4f580a36736604960c8001b6408f1.jpeg",
    "https://cdn.faire.com/fastly/cff6d2c487b75226e1b66fdab64af0951b0c5e5f345c4a9bf46e492b135b6e8d.jpeg",
  ],
  priceDollars: 10,
  description:
    '• Julie Peach original design & illustration\n• 100% cotton\n• 20" Square\n• Machine washable\n• Packaged with belly band, including care instructions\n• Designed in Denver. Silkscreened in India with my production partner that is a Fair Trade International member, certified with the Global Recycled Standard.',
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:10.662Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
